import { styled } from '../../../theme/stitches.config';

export const SMPKnockoutGameContainer = styled.withConfig({ componentId: 'CommonWidget', displayName: 'KnockoutGameContainer' })('div', {
  display: 'grid',
  alignItems: 'center',
  position: 'relative',

  '@bp0': {
    width: 'calc(100% - 20px)',
    '&::after': {
      content: '',
      height: '100%',
      position: 'absolute',
      right: '-10px',
      width: '10px;',
      zIndex: '-1',
    },
    '&:nth-child(even)': {
      marginBottom: '10px',
    },
  },

  '@bp2': {
    width: '100%',
    '> div a > span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '110px',
    },
    '&::after': {
      content: '',
      height: '100%',
      position: 'absolute',
      right: '-20px',
      width: '20px;',
      zIndex: '-1',
    },
    '&:nth-child(even)': {
      marginBottom: '0',
    },
  },

  variants: {
    firstGroup: {
      true: {
        top: '6px',
        '@bp0': {
          '&:nth-child(even)': {
            marginBottom: '10px',
          },
        },
        '@bp2': {
          '&:nth-child(even)': {
            marginBottom: '18px',
          },
        },
      },
    },

    even: {
      true: {
        '&::after': {
          borderBottom: '1px solid $knockoutGameBorderColor',
          borderBottomRightRadius: '$1',
          bottom: '-50%',
        },
      },
    },
    odd: {
      true: {
        '&::after': {
          borderTop: '1px solid $knockoutGameBorderColor',
          borderTopRightRadius: '$1',
          top: '-50%',
          borderRight: '1px solid $knockoutGameBorderColor',
          borderBottomRightRadius: '$1',
        },

        '@bp0': {
          '&::before': {
            borderTop: '1px solid',
            borderColor: '$knockoutGameBorderColor',
            content: '',
            height: '100%',
            position: 'absolute',
            zIndex: '-1',
            right: '-19px',
            width: '9px',
          },
        },
        '@bp2': {
          '&::before': {
            borderTop: '1px solid',
            borderColor: '$knockoutGameBorderColor',
            content: '',
            height: '100%',
            position: 'absolute',
            zIndex: '-1',
            right: '-50px',
            width: '30px',
          },
        },
      },
    },

    removeConnectingLines: {
      true: {
        '@bp0': {
          '&::after': {
            content: '',
            width: '0',
          },
        },
        '@bp2': {
          '&::after': {
            content: '',
            width: '1px',
          },
        },
      },
    },

    smallFinal: {
      true: {
        '@bp0': {
          '&::before': {
            top: '-3px',
          },
        },
        '@bp2': {
          '&::before': {
            top: '-62px',
          },
        },
      },
    },

    smallFinalWithTwoKnockoutGroups: {
      true: {
        '@bp0': {
          '&::before': {
            top: '-3px',
          },
        },
        '@bp2': {
          '&::before': {
            top: '0',
          },
        },
      },
    },

    doublesVariant: {
      true: {
        '@bp2': {
          width: '100%',
          '>div a': {
            alignItems: 'center',
          },
          '>div a span': {
            height: 'auto',
          },
        },
      },
    },

    variant: {
      group: {},
      even: {},
      odd: {},
      removeConnectingLines: {},
      smallFinal: {},
      smallFinalWithTwoKnockoutGroups: {},
      doublesVariant: {},
    },
  },
  compoundVariants: [
    {
      variant: 'group',
      firstGroup: true,
      even: true,
      odd: true,
      css: {},
    },
  ],
});
